import React from "react";
import { Form, Input, Button, Select, message } from "antd";
import { countriesWithCurrencies } from '../../lib/currency';
import SupportPageLayout from "./SupportPageLayout";

const { Option } = Select;

const COUNTRIES_DATA = countriesWithCurrencies;
// const COUNTRIES_DATA = [
//   { code: "IN", name: "India" },
//   { code: "US", name: "United States" },
//   { code: "UK", name: "United Kingdom" },
// ];

const ContactSupport = () => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {

    message.success("Inquiry submitted!");
    form.resetFields();
  };

  return (
    <SupportPageLayout
      title="Contact Support / Sales"
      subtitle="Fill in the details below and our team will get back to you shortly."
    >
      <Form layout="vertical" form={form} onFinish={handleSubmit}>
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="email" label="Email" rules={[{ type: "email", required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="contact" label="Contact No.">
          <Input />
        </Form.Item>
        <Form.Item name="company" label="Company Name">
          <Input />
        </Form.Item>
        <Form.Item name="country" label="Select Country">
          <Select placeholder="Select Country">
            {COUNTRIES_DATA.map((c) => (
              <Option key={c.code} value={c.code}>{c.name}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="message" label="Message">
          <Input.TextArea rows={4} />
        </Form.Item>
        <div style={{ textAlign: "center" }}>
          <Button type="primary" htmlType="submit" style={{ marginRight: 8, marginTop: 8 }}>
            Submit Inquiry
          </Button>
          <Button onClick={() => form.resetFields()}>Clear</Button>
        </div>
      </Form>
    </SupportPageLayout>
  );
};

export default ContactSupport;
